import { useEffect, useState } from "react";

type DeviceType = "mobile" | "tablet" | "desktop" | "smallScreen";

const getDeviceType = (width: number): DeviceType => {
  if (width < 768) {
    return "mobile";
  }
  if (width < 1024) {
    return "tablet";
  }
  if (width < 1440) {
    return "smallScreen";
  }
  return "desktop";
};

export const useDeviceType = (): DeviceType => {
  const [deviceType, setDeviceType] = useState<DeviceType>(() => {
    if (typeof window === "undefined") {
      return "desktop";
    }
    return getDeviceType(window.innerWidth);
  });

  useEffect(() => {
    const handleResize = () => {
      setDeviceType(getDeviceType(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return deviceType;
};
